import React, { Component } from "react";
import Button from "../../../../components/bases/button/button.js";
import { GlobalContext } from "../../../../utils/globalprovider.js";

import DialogInput from "../../../dialogs/input.js";
import DialogInputBox from "../../../dialogs/inputbox.js";
import LabelDialog from "../../../dialogs/labeldialog.js";
import TableSelect from "../../../dialogs/tableselect.js";
import DatePickerBox from "../../../dialogs/datepicker.js";
import OptionSelect from "../../../dialogs/optionselect.js";
import StateInput from "../../../dialogs/stateinput.js";

import {apiGetSeriesList, apiGetClientsList, apiGetDiffusorsList} from "../../../../utils/apis.js"
import {getCurrentUserDatas} from "../../../../utils/software.js"

import imgClose from "./assets/close.png"
import imgBack from "./assets/back.png"
import imgValider from "./assets/valider.png"


import "./projectfilters.css"

class ProjectsFilter extends Component {

  static contextType = GlobalContext;
  constructor(props) {
    super(props);


    this.state ={
            buttons:
                [
                {type:"text", disabled:false,text:{fr:"Réinitialiser",en:"Reset"},key:"reset"},
                //{type:"text", disabled:false,text:{fr:"Refuser",en:"Decline"}, key:"decline"},
                {type:"ok", disabled:false},
                
                ],
            formulaire: this.GetClearSearchDatas(),
            }    

    // Liaison des méthodes
    this.title = {fr:"Filtres",en:"Filters"};


    this.titleRef = React.createRef();
    this.alluserRef = React.createRef();
    this.sherlockRef = React.createRef();
    this.isanRef = React.createRef();
    this.statusRef = React.createRef();
    this.emRef = React.createRef();
    this.serieRef = React.createRef();
    this.clientRef = React.createRef();
    this.diffusorRef = React.createRef();
    this.seasonRef = React.createRef();
    this.episodeRef = React.createRef();
    this.createdateRef = React.createRef();
    this.deliverydateRef = React.createRef();
    this.orderRef = React.createRef();
    this.langoriRef = React.createRef();
    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleButton = this.handleButton.bind(this);
  }

  GetDatasSearchDatas()
  {

    var formulaire = {};
    formulaire.allusers = this.alluserRef.current.getValue();
    formulaire.title= this.titleRef.current.getValue();
    formulaire.sherlock = this.sherlockRef.current.getValue();
    formulaire.isan = this.isanRef.current.getValue();
    formulaire.em = this.emRef.current.getValue();
    formulaire.serie = this.parseIntOrZero(this.serieRef.current.getValue());
    formulaire.client = this.parseIntOrZero(this.clientRef.current.getValue());
    formulaire.diffusor = this.parseIntOrZero(this.diffusorRef.current.getValue());
    formulaire.season = this.parseIntOrZero(this.seasonRef.current.getValue());
    formulaire.episode = this.parseIntOrZero(this.episodeRef.current.getValue());
    formulaire.createdate = this.createdateRef.current.getValue();
    formulaire.deliverydate = this.deliverydateRef.current.getValue();
    formulaire.order = this.parseIntOrZero(this.orderRef.current.getValue());
    formulaire.langori = this.langoriRef.current.getValue();
    formulaire.status = this.statusRef.current.getValue();

    return formulaire;
  }


  GetClearSearchDatas()
  {
      return {
          
          allusers: false,
          title:"",
          sherlock:"",
          isan:"",
          em:"",
          serie:0,
          client:0,
          diffusor:0,
          season: 0,
          episode: 0,
          createdate: "",
          deliverydate:"",
          order: 0,
          langori: "",
          status:0,
      }
  }

parseIntOrZero(value) {
    const parsed = parseInt(value, 10); // Base 10 for parsing
    return isNaN(parsed) ? 0 : parsed; // Return 0 if the parsed value is NaN
}




  handleButton(datas)
  {
    
    switch (datas)
    {
      case "reset":
        var formulaire = this.GetClearSearchDatas();


        
        this.titleRef.current.setValue("")
        this.alluserRef.current.setValue(false)
        this.sherlockRef.current.setValue("")
        this.isanRef.current.setValue("")
        this.emRef.current.setValue("")
        this.serieRef.current.setValue(0)
        this.clientRef.current.setValue(0)
        this.diffusorRef.current.setValue(0)
        this.seasonRef.current.setValue("")
        this.episodeRef.current.setValue("")
        this.createdateRef.current.setValue("")
        this.deliverydateRef.current.setValue("")
        this.statusRef.current.setValue(0)
        this.orderRef.current.setValue(0)
        this.langoriRef.current.setValue(0)


        this.props.onNewSearch (formulaire)

        break;
      case "ok":

        var formulaire = this.GetDatasSearchDatas();

        

        this.props.onNewSearch (formulaire)

      break;
    }
  }


  handleOnChange(datas)
  {
      
  }


  onQuit()
  {
    
  }
  componentDidUpdate()
  {
  }
  componentDidMount() {

  }

  componentWillUnmount() {
  }


  setDisabledButtonByType(type, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].type == type)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }

  setDisabledButtonByKey(key, value)
  {
      var buttons = this.state.buttons;
      var nb = buttons.length;
      for (var i=0; i < nb ; i++)
      {
        if (buttons[i].key == key)
        {
          if (buttons[i].disabled != value)
          {
            buttons[i].disabled = value;
            this.setState({buttons:buttons});
          }
          break;
        }
      }
      
  }

  
  
  render() {
   
    
    
    if (!this.props.display) return (<></>)

      const datausers = getCurrentUserDatas();
      


    // on calcul les boutons
    var buttons = [];
    for (var i=0; i < this.state.buttons.length; i++)
    {
      switch (this.state.buttons[i].type)
      {

        case "text":
          buttons.push(
            <Button 
            button={true}
            text={this.state.buttons[i].text}
            tooltip={null}
            disable={this.state.buttons[i].disabled}
            datas={this.state.buttons[i].key}
            onClick={this.handleButton}
            height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          break;

        case "back":
          buttons.push(
            <Button 
            button={true}
            image={imgBack} 
            tooltip={{fr:"Abandonner",en:"Cancel"}} 
            disable={this.state.buttons[i].disabled}
            datas="back"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          
          break;
        case "ok":
          buttons.push(
            <Button 
            button={true}
            image={imgValider}
            tooltip={{fr:"Rechercher",en:"Search"}} 
            disable={this.state.buttons[i].disabled}
            datas="ok"
            onClick={this.handleButton}
            width={20} height={20}/>
            
          )
          buttons.push(<span>&nbsp;&nbsp;</span>);
          
        }
    }

    var maxheight =  (window.innerHeight * 65)/100;
    if (maxheight > 800) maxheight = 800;

    
    return (
      <>
      
        <div className="projectsFilterInterneDiv" id="innerDivPF"
         
        >
        <div className="projectsFilterTitle"
        onMouseDown={this.handleMouseDown}>
          <div className="projectsFilterTitleText">
          {this.context.language=="fr"?this.title.fr:this.title.en}
          </div>
        </div>

        
        <div className="projectsfilters-container">
                    <DialogInput
                    value = {this.state.formulaire.title}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {true}
                    ref = {this.titleRef}
                    readOnly = {false}
                    width = "175px"
                    title = {this.context.language=="fr"?"Titre":"Title"}
                    />

                  <DialogInputBox
                  value = {this.state.formulaire.allusers}
                  disabled={(datausers.droits & 4) == 0}
                  autoFocus = {false}
                  ref = {this.alluserRef}
                  onChange =  {this.handleOnChange}
                  title = {this.context.language=="fr"?"Tous les utilisateurs":"All users"}
                  />

                    <StateInput
                    value = {this.state.formulaire.status}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    ref = {this.statusRef}
                    forsearch={true}
                    readOnly = {false}
                    title = {this.context.language=="fr"?"Etat : ":"State : "}
                    />



                  <DialogInput
                    value = {this.state.formulaire.sherlock}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.sherlockRef}
                    readOnly = {false}
                    width = "100px"
                    title = {this.context.language=="fr"?"Sherlock":"Sherlock"}
                    />

                    <DialogInput
                    value = {this.state.formulaire.em}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.emRef}
                    readOnly = {false}
                    width = "100px"
                    title = {this.context.language=="fr"?"N° EM":"E.M."}
                    />


                    <TableSelect
                    value = {this.state.formulaire.serie}
                    disabled={false}
                    api={apiGetSeriesList}
                    tableid="seid"
                    tablename = "sename"
                    unselect = {this.context.language=="fr"?"Toutes les séries":"All series"}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.serieRef}
                    readOnly = {false}
                    width = "180px"
                    title = {this.context.language=="fr"?"Série":"Serie"}
                    />

                  <TableSelect
                    value = {this.state.formulaire.client}
                    disabled={false}
                    api={apiGetClientsList}
                    tableid="clid"
                    tablename = "clname"
                    unselect = {this.context.language=="fr"?"Tous les clients":"All clients"}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.clientRef}
                    readOnly = {false}
                    width = "180px"
                    title = {this.context.language=="fr"?"Client":"Client"}
                    />

                    <LabelDialog
                    width = "180px"
                    title = {this.context.language=="fr"?"Trié par :":"Order by :"}
                    />


                    <OptionSelect
                    value = {this.state.formulaire.order}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.orderRef}
                    selectname="order"

                    liste = {
                      [
                        
                        this.context.language=="fr"?"Livraison":"Delivery",
                        this.context.language=="fr"?"Titre":"Title",
                        this.context.language=="fr"?"Création":"Create",
                        this.context.language=="fr"?"Client":"Client",
                        this.context.language=="fr"?"Série":"Série",
                        this.context.language=="fr"?"Saison/Episode":"Season/Episode",
                        this.context.language=="fr"?"Etat":"State",

                      ]
                    }
                    readOnly = {false}
                    width = "180px"
                    />


                    <LabelDialog
                    width = "180px"
                    title = {this.context.language=="fr"?"Autres filtres :":"Other filters :"}
                    />

                    <TableSelect
                    value = {this.state.formulaire.diffusor}
                    disabled={false}
                    api={apiGetDiffusorsList}
                    tableid="diid"
                    tablename = "diname"
                    unselect = {this.context.language=="fr"?"Tous les diffuseurs":"All diffusors"}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.diffusorRef}
                    readOnly = {false}
                    width = "180px"
                    title = {this.context.language=="fr"?"Diffuseur":"Diffusor"}
                    />




                    <DialogInput
                    value = {this.state.formulaire.season}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.seasonRef}
                    readOnly = {false}
                    width = "100px"
                    title = {this.context.language=="fr"?"Saison":"Season"}
                    />

                    <DialogInput
                    value = {this.state.formulaire.episode}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.episodeRef}
                    readOnly = {false}
                    width = "100px"
                    title = {this.context.language=="fr"?"Episode":"Episode"}
                    />


                  <DialogInput
                    value = {this.state.formulaire.isan}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.isanRef}
                    readOnly = {false}
                    width = "180px"
                    title = {this.context.language=="fr"?"Numéro ISAN":"ISAN Number"}
                    />



                    <DatePickerBox
                    value = {this.state.formulaire.createdate}
                    canbeempty={true}
                    autoFocus = {false}
                    ref = {this.createdateRef}
                    readOnly = {false}
                    width = "80px"
                    onChange =  {this.handleOnChange}
                    title = {this.context.language=="fr"?"Création":"Create"}
                    />

                    <DatePickerBox
                    value = {this.state.formulaire.deliverydate}
                    canbeempty={true}
                    autoFocus = {false}
                    ref = {this.deliverydateRef}
                    readOnly = {false}
                    width = "80px"
                    onChange =  {this.handleOnChange}
                    title = {this.context.language=="fr"?"Livraison":"Delivery"}
                    />

                    <DialogInput
                    value = {this.state.formulaire.langori}
                    disabled={false}
                    onChange =  {this.handleOnChange}
                    autoFocus = {false}
                    ref = {this.langoriRef}
                    readOnly = {false}
                    width = "100px"
                    title = {this.context.language=="fr"?"Langue originale":"Original language"}
                    />
      </div>
      <div className="projectsFilterButtonsDiv">
         {buttons}
      </div>
      </div>
      </>
    );
  }
}
ProjectsFilter.defaultProps =
{
    display: true,
}

export default ProjectsFilter;
